import { render, staticRenderFns } from "./FormGroupThux.vue?vue&type=template&id=6fa901fc&"
import script from "./FormGroupThux.vue?vue&type=script&lang=js&"
export * from "./FormGroupThux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports